import { message } from "antd"
import PropTypes from "prop-types"
import React, { useState } from "react"
import InfiniteScroll from "react-infinite-scroll-component"
import styled from "styled-components"

import AdminRoomCard from "../../../_shared/components/AdminRoomCard"
import StyledAppButton from "../../../_shared/components/AppButton"
import RoomsFilter from "../../../_shared/components/FormItems/RoomsFilter"
import { useStateValue } from "../../../_shared/context/AppStateStore"
import useRestList from "../../../_shared/hooks/useRestList"
import { asyncMap } from "../../../_shared/toolkit"
import { createRoom, deleteRoom, updateRoom, uploadFile } from "../../../api"
import RoomsBottomSheet from "./RoomsBottomSheet"

// ----------------------------------------------------------------------------

function _Rooms(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    const { className } = props

    // -------------------------------------
    // Hooks (e.g. useState, ...)
    // -------------------------------------

    const [{ token }] = useStateValue()
    const [
        rooms,
        pagination,
        fetchResource,
        handleFiltersChange,
        handlePaginationChange,
        loading,
        count,
    ] = useRestList("/rooms", token)
    const [selectedRoom, setSelectedRoom] = useState()

    // -------------------------------------
    // Memoized values
    // -------------------------------------

    // -------------------------------------
    // Effects
    // -------------------------------------

    // -------------------------------------
    // Component functions
    // -------------------------------------

    function handleFiltersReceived(filters) {
        handleFiltersChange(filters)
    }

    async function mapImages(values) {
        const body = { ...values }
        const { images } = body
        const mappedImages = await asyncMap(images, async (image) => {
            return typeof image === "string"
                ? image
                : (await uploadFile(image, token))?.url
        })
        return { ...body, images: mappedImages }
    }

    async function handleConfirm(values) {
        const { id } = values
        try {
            const withImages = await mapImages(values)
            id
                ? await updateRoom(id, withImages, token)
                : await createRoom(withImages, token)
            pagination.page === 1
                ? fetchResource()
                : handlePaginationChange({ page: 1 })
            handleCancel()
            message.success("Operazione eseguita con successo")
        } catch (e) {
            message.error("Non è stato possibile eseguire l'operazione.")
        }
    }

    function handleCancel() {
        setSelectedRoom(null)
    }

    async function handleDeleteRoom(room) {
        try {
            await deleteRoom(room?.id, token)
            handleCancel()
            message.success("Stanza eliminata con successo")
            fetchResource()
        } catch (e) {
            //
            message.error("Errore durante l'operazione")
        }
    }

    function loadNextPage() {
        handlePaginationChange({ page: pagination.page + 1 })
    }

    function renderRooms() {
        return (
            <InfiniteScroll
                dataLength={rooms?.length}
                next={loadNextPage}
                hasMore={true}
                loader={<div></div>}
                endMessage={<p></p>}
                className="rooms-grid"
            >
                {rooms?.map((room) => {
                    return (
                        <AdminRoomCard
                            key={room.id}
                            className="room"
                            room={room}
                            onClick={() => setSelectedRoom(room)}
                        ></AdminRoomCard>
                    )
                })}
            </InfiniteScroll>
        )
    }

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    return (
        <div className={`${className}`}>
            <div className="button-wrapper">
                <span className="count">
                    {count ? `${count} risultati` : "..."}
                </span>
                <div className="buttons-right">
                    <RoomsFilter onFilter={handleFiltersReceived} />
                    <StyledAppButton
                        uxType="primary"
                        onClick={() => setSelectedRoom({})}
                    >
                        Aggiungi stanza
                    </StyledAppButton>
                </div>
            </div>
            {renderRooms()}
            <RoomsBottomSheet
                defaultValues={selectedRoom}
                open={!!selectedRoom}
                onConfirm={handleConfirm}
                onCancel={handleCancel}
                onDelete={handleDeleteRoom}
            />
        </div>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

_Rooms.propTypes = {
    className: PropTypes.string.isRequired,
}

_Rooms.defaultProps = {}

// ----------------------------------------------------------------------------

const Rooms = styled(_Rooms)`
    & {
        padding: 40px 60px;
        .button-wrapper {
            display: flex;
            justify-content: space-between;
            margin-bottom: 30px;
            align-items: flex-end;

            .count {
                display: block;
                font-weight: 700;
                font-size: 18px;
            }

            .buttons-right {
                display: flex;
                justify-content: flex-end;
                align-items: center;
            }
        }

        .rooms-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minMax(300px, 1fr));
            grid-gap: 30px;
        }
    }
`
// ----------------------------------------------------------------------------

export default Rooms
